import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'gatsby';
import { ChevronDown } from 'lucide-react';
import type { FC } from 'react';
import { useState } from 'react';
import type { NavLink } from '../../../@types/app';
import { useHeaderMenuBackdrop } from '../header-menu-context';
import { usePathname } from '../../../lib/use-pathname';

function isNavActive(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(`${href}/`);
}

const Submenu: FC<NavLink> = ({ name, submenu, href, menuOnly }) => {
  const [show, setShow] = useState(false);
  useHeaderMenuBackdrop(show);
  const pathname = usePathname();
  const active =
    isNavActive(pathname, href) ||
    (submenu?.some((item) => isNavActive(pathname, item.href)) ?? false);
  const triggerClassName = `site-header__nav-link site-header__nav-link--has-menu${active ? ' site-header__nav-link--active' : ''}`;
  const triggerContent = (
    <>
      <span>{name}</span>
      <ChevronDown
        aria-hidden
        className={`site-header__nav-chevron${show ? ' site-header__nav-chevron--open' : ''}`}
        size={16}
        strokeWidth={2}
      />
    </>
  );

  return (
    <li
      className="site-header__nav-item"
      onMouseEnter={() => {
        setShow(true);
      }}
      onMouseLeave={() => {
        setShow(false);
      }}
    >
      {menuOnly ? (
        <button
          aria-expanded={show}
          aria-haspopup="true"
          className={triggerClassName}
          onClick={() => {
            setShow(true);
          }}
          type="button"
        >
          {triggerContent}
        </button>
      ) : (
        <Link className={triggerClassName} to={href}>
          {triggerContent}
        </Link>
      )}

      <AnimatePresence>
        {show ? (
          <motion.div
            animate={{ opacity: 1 }}
            className="site-header__dropdown"
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
          >
            <ul className="site-header__dropdown-list">
              {submenu?.map((menu) => (
                <li key={menu.href}>
                  <Link
                    className="site-header__dropdown-link"
                    onClick={() => {
                      setShow(false);
                    }}
                    to={menu.href}
                  >
                    {menu.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </li>
  );
};

export default Submenu;
